import * as Scrivito from "scrivito";
import { create } from "zustand";

const localAttrNames: string[] = [
  "localsAE",
  "localsFJ",
  "localsKO",
  "localsPT",
  "localsUZ",
];

export type TranslationsMap = Record<string, string>;

type LocalsObj = Record<string, TranslationsMap>;

type Locals = Record<string, TranslationsMap>;

type UseLocalsStoreState = {
  locals: Locals;
  fetch: (lang: string) => void;
};

export const useLocalsStore = create<UseLocalsStoreState>((set) => ({
  locals: {},
  fetch: async (lang) => {
    const localsObj = await Scrivito.load(() =>
      Scrivito.Obj.where("_objClass", "equals", "Locals").first(),
    );

    const locals: LocalsObj = {};

    if (!localsObj) {
      return;
    }

    localAttrNames.forEach((name) => {
      const localsData = localsObj.get(name) as string;
      const parsedLocalsData = JSON.parse(localsData) as LocalsObj;
      const translations: TranslationsMap = parsedLocalsData?.[lang] || {};
      locals[name] = translations;
    });

    set({ locals });
  },
}));
